import React, { useContext, useState } from "react";
import { Button } from "antd";
import { ModalContext } from "context/ModalContext";
import TableComponent from "./../../components/widgets/table/index";
import AddTermsAndConditions from "./../../components/widgets/forms/setup/AddTermsAndConditions";

export default function ProductTermsAndConditionsConfig() {
  const { modalShow, modalClose } = useContext(ModalContext);

  // Example product table data
  const [productItems] = useState([
    { id: 1, name: "Comprehensive Auto", ref: "AUTO123", underwriters: "ABC Insurance", productImage: "auto.jpg" },
  ]);

  // Terms and Conditions state
  const [termsItems, setTermsItems] = useState([]);

  // Handle form submission
  const handleAddTerm = (term) => {
    setTermsItems((prevItems) => [...prevItems, { ...term, id: prevItems.length + 1 }]);
  };

  // Handle remove term
  const handleRemoveTerm = (id) => {
    setTermsItems((prevItems) => prevItems.filter((item) => item.id !== id));
  };

  // Table fields for products
  const productTableFields = [
    { name: "Product Image" },
    { name: "Name" },
    { name: "Underwriters" },
    { name: "Ref" },
  ];

  const productRowData = [
    { type: "image", field: "productImage", domain: "" },
    { type: "text", field: "name" },
    { type: "text", field: "underwriters" },
    { type: "text", field: "ref" },
  ];

  // Table fields for terms
  const termsTableFields = [
    { name: "Type" },
    { name: "Name" },
    { name: "Content" },
    { name: "Actions" },
  ];

  const termsRowData = [
    { type: "text", field: "type" },
    { type: "text", field: "name" },
    { type: "text", field: "content" },
    { type: "text", field: "actions" },
  ];

  return (
    <div className="p-4">
      {/* Available Products */}
      <div className="mb-5">
        <h2 className="fs-4 mb-3 fw-semibold">Available Products</h2>
        <TableComponent
          table_fields={productTableFields}
          table_data={productItems}
          row_data={productRowData}
          title="Available Products"
          pageSize={10}
        />
      </div>

      {/* Terms and Conditions Form */}
      <div className="mb-5">
        <h2 className="fs-4 mb-3 fw-semibold">Add Terms and Conditions</h2>
        <AddTermsAndConditions onSubmit={handleAddTerm} />
      </div>

      {/* Terms and Conditions Table */}
      <div className="mb-5">
        <h2 className="fs-4 mb-3 fw-semibold">Terms and Conditions</h2>
        <TableComponent
          table_fields={termsTableFields}
          table_data={termsItems.map((item) => ({
            ...item,
            actions: (
              <Button type="link" danger onClick={() => handleRemoveTerm(item.id)}>
                Remove
              </Button>
            ),
          }))}
          row_data={termsRowData}
          title=""
          pageSize={5}
        />
      </div>
    </div>
  );
}